import { render } from "./AccountPopup.vue?vue&type=template&id=5f185a28&scoped=true"
import script from "./AccountPopup.vue?vue&type=script&lang=js"
export * from "./AccountPopup.vue?vue&type=script&lang=js"

import "./AccountPopup.vue?vue&type=style&index=0&id=5f185a28&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f185a28"]])

export default __exports__